import { IGoal } from "motw_core/Entity/IGoal";
import { ELogEntryInputSignificance } from "motw_core/LogEntry/ELogEntryInputSignificance";
import { State } from "source/app/services/UI/State/State";
import { ESharedComponent } from "../../../../services/UI/State/ESharedComponent";
import { IGoalsContainerState } from "../../Goals/IGoalsState";
import { ILogState } from "../ILogState";
import { GetIsFilteringGoalCards } from "./LogInputForm";

export function HandleAddLogEntryChange(stateProperty: string, value: any) {
    const enteredGoalName = value.split(" ")[0]!;

    const isEntryTextEmpty =
        stateProperty === "LogInpEntryText" && value === " ";

    if (isEntryTextEmpty) {
        return;
    }

    const log = State.ReadClass<ILogState>(ESharedComponent.Log);
    if (!log) {
        throw new Error("Cannot find Log component");
    }

    const isMonumentalEntry =
        stateProperty === "inpSignificance" &&
        value ===
            ELogEntryInputSignificance[ELogEntryInputSignificance.Monumental];

    if (!IsAGoal(enteredGoalName)) {
        log.setState({ inpKips: isMonumentalEntry ? "100" : "10" });
    }

    if (IsAGoal(enteredGoalName) && !GoalValueIsAllowed(value, false)) {
        return;
    }

    const newState = { [stateProperty]: value };
    log.setState(newState as {});
}

export function IsAGoal(name: string) {
    if (!GetIsFilteringGoalCards()) {
        return false;
    }

    const goalNames = GetAllGoalNames();
    return goalNames.includes(name);
}

export function GetAllGoalNames() {
    const goalsContainer = State.ReadClass<IGoalsContainerState>(
        ESharedComponent.GoalsContainer
    );

    const goalNames = goalsContainer
        ? goalsContainer.state.Goals.map((goal: IGoal) => goal.name)
        : [];

    return goalNames;
}

export function GoalValueIsAllowed(
    entryText: any,
    isSubmittingEntry: boolean
): boolean {
    const enteredGoalValue = entryText.split(" ")[1];

    if (enteredGoalValue === "") {
        // Allow the goal value to be removed (for example, by pressing backspace)
        // provided that it is not being sent to the database
        return !isSubmittingEntry;
    }

    var isNumberRegexp = /^[0-9]+$/g;
    var regexMatch = isNumberRegexp.exec(enteredGoalValue);
    const goalValueIsAllowed = regexMatch !== null && regexMatch[1] !== null;
    return goalValueIsAllowed;
}

export const defaultLogInputValuesState = {
    inpVerb: "Achieving",
    LogInpEntryText: "",
    inpSignificance: "Important",
    inpKips: "10",
    clickedGoalId: undefined,
};
